"use strict";
import generalFormatter from "../../formatters/general";
import Api from "../../api/api";
import { AdjustmentCalculations } from "./adjustment_calculations";
import CarrierService from "../../services/carrier_service";
import quickpayHelper from "../../helpers/quickpay";
import _ from "../../util/underscore_extensions";
export default React.createClass({
  componentDidMount: function() {
    var id = this.carrierInvoice().carrier_id;
    CarrierService.carrierService.carrierWithId(id).then((carrier) => {
      this.setState({ carrier });
    }).catch(_.identity());
  },
  getInitialState: function() {
    return {
      carrier: {}
    };
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", null, this.possibleAdjustments());
  },
  possibleAdjustments: function() {
    if (this.hasAmountAdjustments()) {
      return /* @__PURE__ */ React.createElement("div", { className: "possible-adjustments__factor-calculation" }, /* @__PURE__ */ React.createElement("div", { className: "row possible-adjustments__starting-calculation-line" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column possible-adjustments__starting-amount" }, this.calculationStartingValue()), /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, this.startingCalculationLabel())), this.possibleOtherInvoicesBreakdown(), this.possibleAdjustmentsBreakdown(), this.possibleQuickpayBreakdown(), /* @__PURE__ */ React.createElement("div", { className: "row possible-adjustments__factor-total-line" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column possible-adjustments__total-amount" }, this.calculationEndingValue()), /* @__PURE__ */ React.createElement("div", { className: "small-7 column possible-adjustments__total-label" }, this.endingCalculationLabel())));
    }
  },
  startingCalculationLabel: function() {
    if (this.props.forExpectedAmount) {
      return "Expected Amount From TMS";
    } else if (this.carrierInvoice().quickpay_disposition === "applied_to_invoice") {
      return "Anticipated Invoice Amount";
    } else {
      return "Invoice Amount";
    }
  },
  endingCalculationLabel: function() {
    if (this.props.forExpectedAmount) {
      return "Adjusted Expected Amount";
    } else if (this.carrierInvoice().quickpay_disposition === "applied_to_invoice" && (this.hasAdjustments() || this.hasOtherInvoiceAdjustments())) {
      return "Adjusted Expected Amount";
    } else if (this.carrierInvoice().quickpay_disposition === "applied_to_invoice") {
      return "Expected Amount";
    } else {
      return "Payment Amount";
    }
  },
  possibleAdjustmentsBreakdown: function() {
    if (this.props.forExpectedAmount) {
      return this.hasAdjustments() ? _.map(this.adjustments(), this.adjustmentBreakdown) : null;
    }
  },
  adjustmentBreakdown: function(adjustment) {
    return this.adjustmentLine(
      adjustment.amount,
      adjustment.reason,
      adjustment.id
    );
  },
  adjustmentLine: function(amount, description, key) {
    return /* @__PURE__ */ React.createElement("div", { className: "row", key }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column possible-adjustments__calculation-line" }, /* @__PURE__ */ React.createElement("div", { className: "operation" }, "- "), generalFormatter.currency(amount)), /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, "TMS Adjustment: ", description));
  },
  possibleQuickpayBreakdown: function() {
    if (!this.props.forExpectedAmount) {
      if (this.carrierInvoice().quickpay_disposition === "not_applied_to_invoice" && this.hasQuickpayAdjustment()) {
        return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column possible-adjustments__calculation-line" }, /* @__PURE__ */ React.createElement("div", { className: "operation" }, "-"), generalFormatter.currency(this.calculations().quickpayDiscountAmountFromCarrierInvoice())), /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, this.quickpayDiscountAmountUsed("CarrierInvoice"), " Quickpay Discount"));
      } else if (this.carrierInvoice().quickpay_disposition === "applied_to_invoice" && this.hasQuickpayAdjustment()) {
        return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column possible-adjustments__calculation-line" }, /* @__PURE__ */ React.createElement("div", { className: "operation" }, " + "), generalFormatter.currency(this.calculations().quickpayDiscountAmountFromTMS())), /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, this.quickpayDiscountAmountUsed("TMS"), " Quickpay Discount"));
      }
    } else {
      return null;
    }
  },
  possibleOtherInvoicesBreakdown: function() {
    if (this.props.forExpectedAmount) {
      return this.hasOtherInvoiceAdjustments() ? _.map(this.otherInvoices(), this.otherInvoiceBreakdown) : null;
    }
  },
  hasAmountAdjustments: function() {
    return this.hasQuickpayAdjustment() || this.hasOtherInvoiceAdjustments() || this.hasAdjustments();
  },
  otherInvoiceBreakdown: function(invoice) {
    return /* @__PURE__ */ React.createElement("div", { className: "row", key: invoice.id }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column possible-adjustments__calculation-line possible-adjustments__calculation-line--other-invoice" }, /* @__PURE__ */ React.createElement("div", { className: "operation" }, "- "), generalFormatter.currency(this.invoiceAmount(invoice))), /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, "Invoice #", invoice.number));
  },
  calculationStartingValue: function() {
    if (this.carrierInvoice().quickpay_disposition === "applied_to_invoice" && !this.props.forExpectedAmount) {
      return generalFormatter.currency(this.actualTotalFromTMS(true, true));
    } else if (this.props.forExpectedAmount) {
      return generalFormatter.currency(this.actualTotalFromTMS());
    } else {
      return generalFormatter.currency(this.totalFromCarrierInvoice());
    }
  },
  totalFromCarrierInvoice: function() {
    return this.invoiceAmount(this.carrierInvoice());
  },
  calculationEndingValue: function() {
    if (this.carrierInvoice().quickpay_disposition === "applied_to_invoice" && !this.props.forExpectedAmount) {
      return generalFormatter.currency(this.actualTotalFromTMS(true));
    } else if (this.props.forExpectedAmount) {
      return generalFormatter.currency(this.actualTotalFromTMS(true, false));
    } else {
      return generalFormatter.currency(this.calculations().actualTotalFromCarrierInvoice(true, this.quickpayAdjustmentFromCarrierInvoice()));
    }
  },
  quickpayAdjustmentFromCarrierInvoice: function() {
    return this.hasQuickpayAdjustment() ? this.calculations().quickpayDiscountAmountFromCarrierInvoice() : 0;
  },
  quickpayAdjustmentFromTMS: function() {
    return this.hasQuickpayAdjustment() ? this.calculations().quickpayDiscountAmountFromTMS() : 0;
  },
  calculations: function() {
    return new AdjustmentCalculations(this.hasQuickpayAdjustment(), this.hasOtherInvoiceAdjustments(), this.hasAdjustments(), this.props.expectedTotal, this.quickpayDiscountPercentage(), this.quickpayDiscountMinimum(), this.totalFromCarrierInvoice(), this.otherInvoicesAdjustment(), this.otherAdjustment());
  },
  actualTotalFromTMS: function(withAdjustments, withQuickpayAdjustment) {
    return this.calculations().actualTotalFromTMS(withAdjustments, withQuickpayAdjustment, this.quickpayAdjustmentFromTMS());
  },
  hasAdjustments: function() {
    return !_.isEmpty(this.adjustments());
  },
  otherAdjustment: function() {
    if (this.hasAdjustments()) {
      return _.sum(_.map(_.pluck(this.adjustments(), "amount"), function(a) {
        return parseFloat(a);
      }));
    } else {
      return 0;
    }
  },
  adjustments: function() {
    return this.load().load.tms_adjustments;
  },
  hasQuickpayAdjustment: function() {
    return quickpayHelper.hasQuickpayAdjustment(this.carrierInvoice(), this.state.carrier);
  },
  quickpayDiscountPercentage: function() {
    return quickpayHelper.quickpayPercentage(this.state.carrier);
  },
  quickpayDiscountMinimum: function() {
    return quickpayHelper.quickpayMinimum();
  },
  quickpayDiscountAmountUsed: function(source) {
    return this.calculations().quickpayDiscountAmountUsed(source);
  },
  accountSettings: function() {
    return Api.Account.currentSettings();
  },
  quickpayWouldBeGreaterThanZero: function() {
    return this.calculations().quickpayDiscountAmountFromCarrierInvoice() > 0 || this.quickpayDiscountFromTMS > 0;
  },
  expectedTotal: function() {
    return this.props.expectedTotal;
  },
  otherInvoicesAdjustment: function() {
    if (this.hasOtherInvoiceAdjustments()) {
      return _.chain(this.otherInvoices()).map(this.invoiceAmount).sum().value();
    } else {
      return 0;
    }
  },
  invoiceAmount: function(invoice) {
    var amount = parseFloat(invoice.amountToPay || invoice.source_invoice_amount);
    return isNaN(amount) ? 0 : amount;
  },
  hasOtherInvoiceAdjustments: function() {
    return this.isDraftStatus() && this.otherInvoices().length > 0;
  },
  isDraftStatus: function() {
    return this.carrierInvoice().state === "draft";
  },
  otherInvoices: function() {
    return _.chain(this.load().carrier_invoices).filter(function(ci) {
      return ci.id !== this.carrierInvoice().id;
    }.bind(this)).filter(function(ci) {
      return ci.state !== "deleted";
    }).filter(function(ci) {
      return ci.state !== "abandoned";
    }).filter(function(ci) {
      return this.invoiceAmount(ci) > 0;
    }.bind(this)).value();
  },
  load: function() {
    return this.props.load;
  },
  carrierInvoice: function() {
    return this.props.carrierInvoice;
  }
});
